<template>
	<div>
		<div>
			<div class="col-lg-12">
				<h2 class="page-header">
					<span id="page-header">{{ pageheader }}</span>
					<a href="/graveyards/" class="hidden-md hidden-lg"><button class="btn btn-success">Zur Liste</button></a>
				</h2>

				<div class="row">
					<h3 class="col-lg-12">Allgemeine Informationen  <router-link class="btn btn-primary create-new pull-right" to="/undertakers/new"><i class="fa fa-plus"></i></router-link></h3>
					<div class="form-horizontal" id="customer-information"></div>

						<custom-input inline>
							<label class="col-sm-12 control-label" for="undertaker_name">Name <span style="color: #f00; font-weight: 800">*</span></label>
							<div class="col-sm-12">
								<input name="undertaker_name" id="undertaker_name" class="form-control" v-model="model.model.name" required>
							</div>
						</custom-input>

						<div class="row">
							<div class="form-group">
								<div class="col-lg-12 text-center">
									<a href="/graveyards/" class="hidden-sm hidden-xs"><button class="btn btn-success">Zur Liste</button></a>
									<button class="btn btn-primary" @click="saveGraveyard()">Speichern</button>
								</div>
							</div>
						</div>

						<div class="row" v-show="model.model.id > 0">
							<div class="col-lg-12">
								<div class="col-lg-12">
									<ul class="nav nav-tabs responsive-tabs">
										<li class="active"><a href="#addresses">Adressen</a></li>
										<li><a href="#contacts">Kontakte</a></li>
									</ul>

									<div class="tab-content col-lg-12">
										<div class="tab-pane active" id="addresses">
											<custom-table :cols="addresses.cols" :src-model="model.addresses" add delete edit nosort @add="addAddress" @edit="editAddress" @delete="deleteAddress"></custom-table>
										</div>

										<div class="tab-pane" id="contacts">
											<custom-table :cols="contacts.cols" :src-model="model.contacts" add delete edit nosort @add="addContact" @edit="editContact" @delete="deleteContact"></custom-table>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>

			<!-- Adressen -->
			<custom-modal ref="addressModal" title="Adresse hinzufügen" ok-text="Speichern" cancel-text="Abbrechen" ok-style="btn btn-primary" cancel-style="btn btn-default">
				<address-content ref="newAddress"></address-content>
			</custom-modal>

			<!-- Kontakt -->
			<custom-modal ref="contactModal" title="Kontakt hinzufügen" ok-text="Speichern" cancel-text="Abbrechen" ok-style="btn btn-primary" cancel-style="btn btn-default">
				<contact-content ref="newContact"></contact-content>
			</custom-modal>

			<custom-modal-old title="Kontakt entfernen" v-if="visibleModal === 'deletecontacts'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('contacts')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
				<strong>Sind Sie sicher, dass Sie diesen Kontakt entfernen möchten?</strong>
			</custom-modal-old>

			<custom-modal-old title="Adresse entfernen" v-if="visibleModal === 'deleteaddresses'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('addresses')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
				<strong>Sind Sie sicher, dass Sie diese Adresse entfernen möchten?</strong>
			</custom-modal-old>

			<!-- Fehlermeldungen -->
			<custom-modal-old v-if="visibleModal === 'errSavingModel'" @ok="visibleModal = ''" ok-text="OK" @cancel="visibleModal = ''">
				Fehler beim Speichern des Kunden.
			</custom-modal-old>
		</div>
	</div>

</template>

<script>
import CustomTable from 'components/custom-table.vue'
import CustomModal from 'components/custom-modal.vue'
import CustomModalOld from 'components/custom-modal-old.vue'
import CustomInput from 'components/custom-input.vue'
import AddressContent from 'components/address-content.vue'
import ContactContent from 'components/contact-content.vue'

import Datepicker from 'vuejs-datepicker'

import GraveyardModel from 'models/graveyards.js'

import AddressModel from 'models/addresses.js'
import ContactModel from 'models/contacts.js'
import DeceasedModel from 'models/deceaseds.js'

import modelTools from 'functions/models.js'
import relationTools from 'functions/relations.js'
import addressTools from 'functions/address.js'
import contactTools from 'functions/contact.js'
import deceasedTools from 'functions/deceased.js'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('graveyards')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	beforeRouteLeave(to, from, next) {
		if (to.path === '/'+this.model.name+'/new') {
			this.model.clear()
		}
		next()
	},

	// Normale Eigenschaften
	data () {
		return {
			model: GraveyardModel,

			addresses: AddressModel,
			contacts: ContactModel,

			// visibleModal: 'addgraves'
			visibleModal: '',
			selectAreaMode: 'relation',

			addressesCols: [
				{ name: 'Name', json: 'name', type: 'text' },
				{ name: 'Von', json: 'from', type: 'date' },
				{ name: 'Bis', json: 'until', type: 'date' }
			],

			contactsCols: [
				{ name: 'Name', json: 'name', type: 'text' },
				{ name: 'Von', json: 'from', type: 'date' },
				{ name: 'Bis', json: 'until', type: 'date' }
			],

			deceasedsCols: [
				{ name: 'Name', json: 'name', type: 'text' },
				{ name: 'Geburtstag', json: 'birthday', type: 'date' },
				{ name: 'Todestag', json: 'dyingday', type: 'date' }
			],

			deceasedSearchCols: [
				{ name: 'Name', json: 'firstname', type: 'text' },
				{ name: 'Name', json: 'lastname', type: 'text' },
				{ name: 'Geburtstag', json: 'birthday', type: 'date' },
				{ name: 'Todestag', json: 'dyingday', type: 'date' }
			],

			customerSearchCols: [
				{ name: 'Vorname', json: 'firstname', type: 'text' },
				{ name: 'Nachname', json: 'lastname', type: 'text' }
			],

			areaCols: [
				{ name: 'Name', json: 'name', type: 'text' },
				{ name: 'Preis', json: 'real_price', type (aValue) { return [ aValue + ' €' ] } }
			],

			graveTypeCols: [
				{ name: 'Name', json: 'name', type: 'text' },
				{ name: 'Kürzel', json: 'short_name', text: 'text' }
			],

			defSort: {col: 'id', order: 'asc'}
		}
	},

	activated () {
		this.model.clear()
		this.model.model.id = parseInt(this.$route.params.id)
		if (isNaN(this.model.model.id)) {
			this.model.model.id = 0
		}

		this.$store.dispatch('loadModels', this.model.relations)

		this.$store.dispatch('loadModel', 'graveyards')
		.then(result => {
			var model = this.$store.getters.model('graveyards', this.model.model.id)
			this.model.copy(model)
			this.model.model.name = model.name

			this.$store.dispatch('loadRelation', {basis: this.model, relation: 'addresses'})
			.then(data => this.initRelation('addresses', data))

			this.$store.dispatch('loadRelation', {basis: this.model, relation: 'contacts'})
			.then(data => this.initRelation('contacts', data))

			$('.responsive-tabs').responsiveTabs({
				accordionOn: ['xs', 'sm'] // xs, sm, md, lg
			})
		})
	},

	computed: {
		type_id: {
			get () {
				return this.model.model.type_id
			},

			set (newValue) {
				this.model.model.type_id = newValue
				if (this.model.model.name === '') {
					let CountType = this.$store.getters.models('graveyards').filter(Value => Value.type_id === newValue).length + 1
					this.model.model.name = this.$store.getters.model('graveyards', newValue).name + ' ' + CountType
				}
			}
		},

		validGrave () {
			return this.model.model.name !== '' && this.model.model.area_id !== 0
		},

		pageheader () {
			let model
			let name

			if (this.model.model.id === 0) {
				return 'Neuen Friedhof anlegen'
			} else {
				model = this.$store.getters.model('graveyards', this.model.model.id)
				name = model.name

				return 'Friedhof "' + name.trim() + '" verwalten'
			}
		},

		area_price () {
			console.log(this.model.model.area_price, this.model.model.category_price)

			return parseFloat(this.model.model.area_price) < 1 ? parseFloat(this.model.model.category_price) : parseFloat(this.model.model.area_price)
		}
	},

	components: {
		CustomTable,
		CustomModal,
		CustomModalOld,
		CustomInput,
		Datepicker,
		AddressContent,
		ContactContent
	},

	methods: {
		// Tools des Models
		saveModel: modelTools.save,

		// Beziehungen zwischen Models
		initRelation: relationTools.init,
		editRelation: relationTools.edit,
		deleteRelation: relationTools.delete,
		addRelation: relationTools.add,
		saveRelation: relationTools.save,
		confirmDeleteRelation: relationTools.confirmDelete,

		// Adress speziefische Methoden
		addressModal () {
			this.$refs.addressModal.open( () => {
				// Callback um zzu prüfen ob das Modal geschlossen werden kann
				if (this.$refs.newAddress.model.model.street.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.number.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.zip.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.city.trim() === "") {
					return false
				}

				return true
			})
			.then(() => {
				this.saveRelation('addresses')
			})
			.catch(() => {
				// Erfolgloses schließen
				console.log("CANCEL")
			})
		},

		addAddress () {
			this.addresses.clear()
			this.addressModal()
		},

		// Adressen speziefische Methoden
		editAddress (aModel) {
			this.addresses.copy(aModel)
			this.addressModal()
		},

		deleteAddress: addressTools.delete,

		// Nutzungsberechtigten speziefische Methoden
		contactModal () {
			this.$refs.contactModal.open( () => {
				if (this.$refs.newContact.model.model.value.trim() === "") {
					return false
				}

				return true
			})
			.then(() => {
				this.saveRelation('contacts')
			})
			.catch(() => {
				console.log("CANCEL")
			})
		},

		addContact () {
			this.contacts.clear()
			this.contactModal()
		},

		// Adressen speziefische Methoden
		editContact (aModel) {
			this.contacts.copy(aModel)
			this.contactModal()
		},

		deleteContact: contactTools.delete,

		// Grab speziefische Methoden
		editDeceased: deceasedTools.edit,
		deleteDeceased: deceasedTools.delete,

		saveCustomer (aModel) {
			// this.deceaseds.copy(aModel)
			this.customers.model.name = aModel.id + ': Dummy'
			this.customers.model.id = 0
			this.saveRelation('customers')
			this.visibleModal = ''
		},

		updateCustomer () {
			this.customers.model.name = this.customers.model.customer_id + ': Dummy'
			this.saveRelation('customers')
			this.visibleModal = ''
		},

		updateDeceased () {
			this.deceaseds.model.name = this.deceaseds.model.deceased_id + ': Dummy'
			this.saveRelation('deceaseds')
			this.visibleModal = ''
		},

		saveDeceased (aModel) {
			// this.deceaseds.copy(aModel)
			this.deceaseds.model.name = aModel.id + ': Dummy'
			this.deceaseds.model.id = 0
			this.saveRelation('deceaseds')
			this.visibleModal = ''
		},

		saveGraveyard () {
			this.saveModel()
			.then(id => {
				this.model.model.id = id
				this.$router.replace("/graveyards/" + id)
			})
			.catch(id => {
				this.model.model.id = id
			})
		},

		selectArea () {
			this.visibleModal = 'selectArea'
		},

		clearArea () {
			this.model.model.area_id = 0
			this.model.model.area_name = '[Keine Fläche]'
		},

		pickArea (aModel) {
			this.model.model.area_id = aModel.id
			this.model.model.area_name = aModel.name
			this.visibleModal = ''
		},

		newArea () {
			this.saveModel(this.areas, true)
				.then(response => {
					console.log(response);
					this.pickArea(response)
				})
				.catch(err => {
					console.log(err)
				})
		},

		print (aModels) {
			aModels[0] = aModels[0].map(aValue => {
				return {text: aValue, style: 'tableHeader', alignment: 'center'}
			})

			let dd = {
				footer: function (currentPage, pageCount) {
					return { text: 'Seite ' + currentPage + ' von ' + pageCount, alignment: (currentPage % 2) ? 'left' : 'right' };
				},

				content: [
					{
						table: {
							headerRows: 1,
							widths: ['*', '*', '*', '*'],

							body: aModels
						}
					}
				],
				styles: {
					header: {
						fontSize: 18,
						bold: true,
						margin: [0, 0, 0, 10]
					},
					subheader: {
						fontSize: 16,
						bold: true,
						margin: [0, 10, 0, 5]
					},
					tableExample: {
						margin: [0, 5, 0, 15]
					},
					tableHeader: {
						bold: true,
						fontSize: 13,
						color: 'black'
					}
				}
			}

			pdfMake.createPdf(dd).open()
		}
	}
}
</script>

<style>
	.addon-primary {
		background-color: #337ab7;
		color: white;
	}

	.addon-primary:hover {
		background-color: #286090;
		color: white;
		cursor: pointer;
	}

	.addon-success {
		background-color: #5cb85c;
		color: white;
	}

	.addon-success:hover {
		background-color: #3F903F;
		color: white;
		cursor: pointer;
	}

	.addon-danger {
		background-color: #d9534f;
		color: white;
	}

	.addon-danger:hover {
		background-color: #C9302C;
		color: white;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// GraveyardEdit.vue?c364b5fc